const services = {
	youtube: {
		hosts: ['youtu.be', 'youtube.com', 'www.youtube.com'],
		rules: {
			id_length: 11,
		},
	},
	vimeo: {
		hosts: ['vimeo.com', 'player.vimeo.com'],
	},
};

function youTubeParser(url) {
	const regExp =
		/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?vi?=|&vi?=))([^#&?]*).*/;
	const match = url.match(regExp);
	return match && match[1] ? match[1] : false;
}

const getEmbeddedVideo = url => {
	let parsed = null;

	try {
		parsed = new URL(url);
	} catch {
		return null;
	}

	if (services.youtube.hosts.includes(parsed.hostname)) {
		const hash = youTubeParser(url);
		if (hash && hash.length === services.youtube.rules.id_length) {
			return `https://www.youtube.com/embed/${hash}`;
		}
	} else if (services.vimeo.hosts.includes(parsed.hostname)) {
		return url;
	}
	return null;
};

export default getEmbeddedVideo;
